import { Icon } from '@frontend/icons';
import { Chip } from '@frontend/design-system';
import type { FilterableCheckboxListItem } from '../../components/filterable-checkbox-list/use-filterable-checkbox-list';
import {
  APPOINTMENT_STATUS_MAPPING,
  AppointmentStatusEnum,
} from '../../components/schedule-calendar-components/appointment-event-card/types';

export const AppointmentStatusFilterLabel = ({ item }: { item: FilterableCheckboxListItem }) => {
  const normalizedKey = item.value.toLowerCase().replace(/[\s_]/g, '') as AppointmentStatusEnum;
  const statusInfo = APPOINTMENT_STATUS_MAPPING.get(normalizedKey);

  if (!statusInfo) {
    return <span css={{ textTransform: 'capitalize' }}>{item.label}</span>;
  }

  return (
    <Chip
      variant={statusInfo.variant}
      css={{ minWidth: 'fit-content', maxWidth: '100%', textTransform: 'capitalize' }}
      leftElement={<Icon name={statusInfo.iconName} css={{ color: 'currentcolor' }} />}
    >
      {item.label}
    </Chip>
  );
};
